"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMachine = void 0;
var workflow_1 = require("@newfront-insurance/workflow");
var react_1 = require("react");
var xstate_1 = require("xstate");
var types_1 = require("./lib/types");
var Actions;
(function (Actions) {
    Actions["UPDATE_DATA"] = "UPDATE_DATA";
})(Actions || (Actions = {}));
function getMachine(billing) {
    var _a, _b, _c, _d, _e, _f;
    return xstate_1.Machine({
        initial: types_1.Steps.PRIMARY_REASON_STEP,
        // set initial values for the form
        context: {
            initialBillingChanges: {
                premium: {
                    current: billing.premium,
                    updated: billing.premium,
                },
                stateTax: {
                    current: billing.stateTax || 0,
                    updated: billing.stateTax || 0,
                },
                stateStampingFee: {
                    current: billing.stateStampingFee || 0,
                    updated: billing.stateStampingFee || 0,
                },
                miscTaxesAndFees: {
                    current: billing.miscTaxesAndFees || 0,
                    updated: billing.miscTaxesAndFees || 0,
                },
                carrierPolicyFee: {
                    current: billing.carrierPolicyFee || 0,
                    updated: billing.carrierPolicyFee || 0,
                },
                newfrontFee: {
                    current: billing.newfrontFee || 0,
                    updated: billing.newfrontFee || 0,
                },
                wholesaleFee: {
                    current: billing.wholesaleFee || 0,
                    updated: billing.wholesaleFee || 0,
                },
            },
            billingChanges: undefined,
            primaryReason: undefined,
            policyChangeRequired: false,
            secondaryReason: undefined,
            cancellationDate: undefined,
            effectiveDate: undefined,
            notes: undefined,
            status: undefined,
        },
        states: (_a = {},
            _a[types_1.Steps.PRIMARY_REASON_STEP] = {
                on: (_b = {},
                    _b[workflow_1.WorkflowEvents.NEXT] = {
                        target: types_1.Steps.SECONDARY_REASON_STEP,
                        actions: [Actions.UPDATE_DATA],
                    },
                    _b),
            },
            _a[types_1.Steps.SECONDARY_REASON_STEP] = {
                on: (_c = {},
                    _c[workflow_1.WorkflowEvents.BACK] = {
                        target: types_1.Steps.PRIMARY_REASON_STEP,
                        actions: [Actions.UPDATE_DATA],
                    },
                    _c[workflow_1.WorkflowEvents.NEXT] = [
                        {
                            target: types_1.Steps.CANCELLATION_POLICY_CHANGE_STEP,
                            actions: [Actions.UPDATE_DATA],
                            // Only transition to 'searching' if the guard (cond) evaluates to true
                            cond: 'isCancelled', // or { type: 'searchValid' }
                        },
                        {
                            target: types_1.Steps.SECONDARY_REASON_STEP,
                            actions: [Actions.UPDATE_DATA],
                        },
                    ],
                    _c),
            },
            _a[types_1.Steps.CANCELLATION_SECONDARY_REASON_STEP] = {
                on: (_d = {},
                    _d[workflow_1.WorkflowEvents.BACK] = {
                        target: types_1.Steps.PRIMARY_REASON_STEP,
                        actions: [Actions.UPDATE_DATA],
                    },
                    _d[workflow_1.WorkflowEvents.NEXT] = {
                        target: types_1.Steps.COMPLETE,
                        actions: [Actions.UPDATE_DATA],
                    },
                    _d),
            },
            _a[types_1.Steps.CANCELLATION_POLICY_CHANGE_STEP] = {
                on: (_e = {},
                    _e[workflow_1.WorkflowEvents.BACK] = {
                        target: types_1.Steps.SECONDARY_REASON_STEP,
                        actions: [Actions.UPDATE_DATA],
                    },
                    _e[workflow_1.WorkflowEvents.NEXT] = {
                        target: types_1.Steps.COMPLETE,
                        actions: [Actions.UPDATE_DATA],
                    },
                    _e),
            },
            _a[types_1.Steps.COMPLETE] = {
                type: 'final',
            },
            _a),
    }, {
        guards: {
            isCancelled: function (context) { return context.primaryReason === types_1.PrimaryReason.CUSTOMER_CANCEL; },
        },
        actions: (_f = {},
            _f[Actions.UPDATE_DATA] = xstate_1.assign(function (_context, event) { return event.data; }),
            _f),
    });
}
function useMachine(billing) {
    var machine = react_1.useMemo(function () { return getMachine(billing); }, [billing]);
    return machine;
}
exports.useMachine = useMachine;
